import styled from 'styled-components';

const H6 = styled.h6`
  font-size: 18px;
  margin: 0;
`;

export default H6;
